import {customElement, bindable, inject, LogManager} from 'aurelia-framework';
import {Client} from '../api/client';
import * as _ from 'lodash';
import {I18N} from "aurelia-i18n";
import {ColumnLoader} from "./column-loader";

const logger = LogManager.getLogger('property-display');

/**
 * Class to display a property of an object
 */
@customElement('property-display')
@inject(Client, I18N, ColumnLoader)
export class PropertyDisplay
{
    @bindable object;
    @bindable field;

    column;

    constructor(client, i18n, columnLoader)
    {
        this.client = client;
        this.i18n = i18n;
        this.columnLoader = columnLoader;
    }

    async bind()
    {
        this.objectChanged();
    }

    async objectChanged()
    {
        this.column = null;

        if (!this.field) {
            return;
        }

        let columns = await this.columnLoader.loadColumns(this.object, [this.field]);

        if (columns.length === 1) {
            this.column = columns[0];
        }
    }

    getNested(column, object) {
        if (!column.nestedProperty) {
            return object;
        }

        return _.get(object, column.nestedProperty);
    }
}
